import React from 'react';
import { IconProps } from '.';

const SvgCategoryZDelivery = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M4.833 6.333c0-.184.15-.333.334-.333h11.7c.184 0 .333.15.333.333v2.9h1.967A2.852 2.852 0 0 1 22 12.067v4.366c0 .184-.15.334-.333.334h-2.675A2.17 2.17 0 0 1 16.9 19.5a2.167 2.167 0 0 1-2.092-2.733h-4.25A2.17 2.17 0 0 1 8.468 19.5a2.167 2.167 0 0 1-2.092-2.733H5.167a.333.333 0 0 1 0-.667h1.51a2.143 2.143 0 0 1 1.79-.967c.755 0 1.41.393 1.79.967h4.82a2.15 2.15 0 0 1 1.456-.94V6.666H5.167a.333.333 0 0 1-.334-.334Zm12.4 8.826V9.9h1.934c1.182 0 2.166.984 2.166 2.167V16.1H18.69a2.15 2.15 0 0 0-1.456-.94Zm-8.766.674a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm8.433 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z'
        clipRule='evenodd'
      />
      <path
        fill={color}
        d='M2 9.1c0-.184.15-.333.333-.333h2.834a.333.333 0 0 1 0 .666H2.333A.333.333 0 0 1 2 9.1ZM3.033 11.133c0-.184.15-.333.334-.333h3.266a.333.333 0 1 1 0 .667H3.367a.333.333 0 0 1-.334-.334ZM2 13.167c0-.184.15-.334.333-.334h3.834a.333.333 0 0 1 0 .667H2.333A.333.333 0 0 1 2 13.167ZM10.287 9.727V8.5H13.7l-1.56 4.02h1.473v1.23H10.2l1.572-4.023h-1.486Z'
      />
    </svg>
  );
};

export default SvgCategoryZDelivery;
